<template>
  <div>
    <h2 class="content-block">Practice Loading Screen</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
